// import { Direction } from '@mui/material';

import { Mode, ThemeConfig } from '../@types';

export const themeConfig: ThemeConfig = {
  layout: 'vertical',
  mode: 'light' as Mode,
  skin: 'bordered',
  contentWidth: 'boxed',
  footer: 'static',

  // ** Navigation (Menu) Configs
  navHidden: false,
  menuTextTruncate: true,
  navSubItemIcon: 'mdi:circle',
  verticalNavToggleType: 'collapse',
  navCollapsed: false,
  navigationWidth: 260,
  collapsedNavigationWidth: 68,
  afterVerticalNavMenuContentPosition: 'fixed',
  beforeVerticalNavMenuContentPosition: 'fixed',
  horizontalMenuToggle: 'hover',
  horizontalMenuAnimation: true,

  // ** AppBar Configs
  appBar: 'fixed',
  appBarBlur: true,

  // ** Other Configs
  responsiveFontSizes: false,
  disableRipple: false,
  enableCustomizer: false,
  toastPosition: 'top-right',
};

export default themeConfig;
